import { API } from 'utils/axios'

export const createChat = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/mentalHealth-startChat`
  //  const url = 'http://localhost:5000/yourdoctorsonline-staging/northamerica-northeast1/mentalHealth-startChat'
  return await API.POST(url, payload)
}

export const endChat = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/mentalHealth-mentalHealthEndChat`
  // const url = 'http://localhost:5000/yourdoctorsonline-staging/northamerica-northeast1/mentalHealth-mentalHealthEndChat'
  return await API.POST(url, payload)
}

export const generateLink = async (payload) => {

  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/mentalHealth-ZapierVideoLink`
  return await API.POST(url, payload)
}

export const getToken = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/doctorDashboard-getAgoraToken`
  return await API.POST(url, payload)
}
export const generateDeepLink = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/generateDeepLink`
  return await API.POST(url, payload)
}
export const customCloudMessage = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL}/customCloudMessage`
  return await API.POST(url, payload)
}
export const callNotificationVOIP = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/callNotificationVOIP`
  return await API.POST(url, payload)
}

export const getDoctorDetails = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/mentalHealth-fetchDoctorDetails`
  return await API.POST(url, payload)
}

export const changeAppointment = async (payload) => {
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/mentalHealth-reScheduleAppointment`
  return await API.POST(url, payload)
}

export const soapNoteAIMeeting = async (payload) => {
  // const url = `https://14a7026b4627.ngrok-free.app/yourdoctorsonline-staging/northamerica-northeast1/sopaNotesAiPostMeeting`
  const url = `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/soapNotesAiPostMeeting`
  return await API.POST(url, payload)
}